/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      console.log('[CART] on:cart-drawer:before-open fired');
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      // Wait for slider items to be fully populated before initializing
      this.initializeCartSliders('before-open');
    });
    this.addEventListener('on:cart:after-merge', () => {
      console.log('[CART] on:cart:after-merge fired');
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      // Wait for slider items to be fully populated before initializing
      this.initializeCartSliders('after-merge');
    });
  }

  /**
   * Initialize cart cross-sell sliders after items are loaded
   */
  initializeCartSliders(source) {
    console.log(`[CART] initializeCartSliders called from: ${source}`);
    
    this.querySelectorAll('cc-cart-cross-sell carousel-slider').forEach((slider) => {
      const productGrid = slider.querySelector('.product-grid');
      console.log('[CART] Product grid:', productGrid);
      console.log('[CART] Product grid children:', productGrid ? productGrid.children.length : 0);
      
      // If products already loaded, initialize immediately
      if (productGrid && productGrid.children.length > 0) {
        const slides = slider.querySelectorAll('.slider__item:not([hidden])');
        console.log('[CART] Slides found:', slides.length);
        
        if (slides.length >= 2 && slider.init) {
          console.log('[CART] Products already loaded - initializing slider immediately');
          slider.removeAttribute('loaded');
          slider.init();
          console.log('[CART] Slider initialized successfully');
        }
      } else {
        // Products not loaded yet - watch for them to be added
        console.log('[CART] Products not loaded - setting up MutationObserver');
        
        if (productGrid) {
          const observer = new MutationObserver((mutations) => {
            const slides = slider.querySelectorAll('.slider__item:not([hidden])');
            console.log('[CART] MutationObserver detected change - slides:', slides.length);
            
            if (slides.length >= 2 && slider.init) {
              console.log('[CART] Products loaded via observer - initializing slider');
              slider.removeAttribute('loaded');
              slider.init();
              console.log('[CART] Slider initialized successfully');
              observer.disconnect();
            }
          });
          
          observer.observe(productGrid, {
            childList: true,
            subtree: true
          });
          
          // Fallback timeout in case observer doesn't fire
          setTimeout(() => {
            observer.disconnect();
            console.log('[CART] Observer timeout - disconnected');
          }, 2000);
        }
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
